export const TICKS_PER_SECOND = 48_000;
export const TICKS_PER_FRAME = 2_000;
export const FRAME_RATE = 24;
export const SMOKE_FRAME_COUNT = 120;
export const SMOKE_SAMPLE_COUNT = SMOKE_FRAME_COUNT * TICKS_PER_FRAME;
export const MIN_FRAMES = 24;
export const MAX_FRAMES = 720;

export function assertFrameCount(frameCount: number): void {
  if (!Number.isSafeInteger(frameCount) || frameCount < MIN_FRAMES || frameCount > MAX_FRAMES) {
    throw new RangeError(`frameCount must be a safe integer between ${MIN_FRAMES} and ${MAX_FRAMES}; got ${frameCount}`);
  }
}

export function frameTimestampUs(frameIndex: number): number {
  if (!Number.isSafeInteger(frameIndex) || frameIndex < 0) {
    throw new RangeError(`frameIndex must be a non-negative safe integer; got ${frameIndex}`);
  }
  const numerator = frameIndex * TICKS_PER_FRAME * 1_000_000;
  return Math.floor((numerator + TICKS_PER_SECOND / 2) / TICKS_PER_SECOND);
}

export function frameDurationUs(frameIndex: number): number {
  return frameTimestampUs(frameIndex + 1) - frameTimestampUs(frameIndex);
}

export function exactSampleCount(frameCount: number): number {
  assertFrameCount(frameCount);
  return frameCount * TICKS_PER_FRAME;
}

export function frameCountToTicks(frameCount: number): bigint {
  assertFrameCount(frameCount);
  return BigInt(frameCount * TICKS_PER_FRAME);
}
